import React from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import IndexApp from "../../Components/IndexApp";
import { getSupportContact } from "../../config/supportContact";
import { DV2 } from "../../App/DeclarationV2/theme";
import { Card, TextLink, useDv2Theme } from "../../App/DeclarationV2/layout/Ui";
import HelpV2Form from "../../App/HelpV2/HelpV2Form";

/**
 * Page « Aide et contact » du prof (maquettes 1l et 2l) : formulaire avec
 * sujet, cours concerné et rappel, coordonnées de l'équipe. Les « réponses
 * rapides » (FAQ) de la maquette viendront dans un lot ultérieur.
 * La page historique (HelpPage) reste servie aux clients.
 */
const HelpV2Page = () => {
    const { fontFamily, brandName } = useDv2Theme();
    const location = useLocation();
    const teachr = useSelector((s: any) => s?.user?.currentUser?.teachr);
    const contact = getSupportContact();
    const defaultSubject = (location.state as any)?.subject as string | undefined;
    const defaultCallback = (location.state as any)?.callback === true;
    const defaultContext = (location.state as any)?.context as string | undefined;

    return (
        <IndexApp
            navBar={{ index: 0 }}
            teachr={teachr}
            component={
                <main className="px-4" style={{ background: DV2.pageBg, minHeight: "calc(100vh - 64px)", fontFamily, color: DV2.text }}>
                    <div className="mx-auto w-full /max-w-6xl px-4 sm:px-6 py-6 lg:py-9 grid gap-6 lg:gap-8 lg:grid-cols-[minmax(0,1fr)_360px] items-start">
                        <div className="flex flex-col gap-6 min-w-0">
                            <div className="flex flex-col gap-1">
                                <h1 style={{ fontSize: 28, fontWeight: 800, margin: 0 }} className="lg:text-[30px]">Comment pouvons-nous vous aider ?</h1>
                                <p style={{ fontSize: 15, color: DV2.muted, margin: 0, lineHeight: 1.55 }}>Dites-nous de quoi il s'agit, l'équipe {brandName} vous répond en général sous un jour ouvré.</p>
                            </div>
                            <HelpV2Form teachr={teachr} defaultSubject={defaultSubject} defaultCallback={defaultCallback} defaultContext={defaultContext} />
                        </div>

                        <div className="flex flex-col gap-4">
                            <Card style={{ display: "flex", flexDirection: "column", gap: 6, padding: 22 }} as="section" aria-label="Par e-mail">
                                <div style={{ fontWeight: 800, fontSize: 15 }}>Par e-mail</div>
                                <TextLink label={contact.email} href={`mailto:${contact.email}`} size={15} />
                                <div style={{ fontSize: 13, color: DV2.muted, lineHeight: 1.45 }}>
                                    {contact.hours.charAt(0).toUpperCase() + contact.hours.slice(1)}. Réponse sous un jour ouvré en général.
                                </div>
                                {contact.phone && <TextLink label={contact.phoneDisplay ?? contact.phone} href={`tel:${contact.phone}`} size={15} />}
                            </Card>
                        </div>
                    </div>
                </main>
            }
        />
    );
};

export default HelpV2Page;
